module.exports = __webpack_public_path__ + "static/img/Lxzk5000.782c4137.png";